import _ from 'lodash'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'
import qs from 'qs'
import { removeEmpty } from 'utils'
export const mapFieldIncident = (item,index) => {
    return {
        key: item?.report_header_id,
        reportTypeName: item?.report_type?.report_type_name,
        reportTypeId: item?.report_type_id,
        reportStatusId: item?.report_status_id,
        reportHeaderId: item?.report_header_id,
        reportDate: item?.report_date,
        reportAttributeValue: item.report_attribute_value,
        reportCodeCd: item?.reportcode_cd,
        investigateCodeCd: item?.investigatecode_cd,
        riskCoordinator: item?.riskcoordinator?.profile?.profile_name,
        incidentTopic: item?.incident_topic,
        isSignificant: item?.is_significant,
        apStatus: item?.ap_status,
        riskOwner: item?.risk_owner,
        riskLevelName: item?.risk_level_before?.risk_level_group?.value_list_name,
        riskLevelColorName: item?.risk_level_before?.risk_level_color?.value_list_name,
        riskOwnerOrgName: item?.risk_owner_org_name
    }
}

export const getIncidentListApi = async (req) => {
    const params = removeEmpty(req)
    const config = {
        method: 'get',
        url: '/api/v1/incident/?parent_only=true',
        params: params,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        },
    }
    console.log(config)
  try {
    const {data, status} = await defaultInstance.request(config)
    if(status !== 200) {
        return responseError({ message: 'API something went wrong' })
    }
    return responseSuccess({data: {...data,items: _.map(data.items,mapFieldIncident)}})

  } catch (err) {
    if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
  }
}
